import React, { useEffect } from "react";
import {
  Image,
  withSitecoreContext,
  Link,
} from "@sitecore-jss/sitecore-jss-react";

import "./index.scss";
import { IconButtonModel } from "./models/IconButton.model";
import { IconButtonProps } from "./types/IconButton.types";

const IconButton = (props: IconButtonProps) => {
  const model = new IconButtonModel(props);
  const undifinedServer = typeof document !== 'undefined' && typeof window !== 'undefined';

  if (undifinedServer) {
    const getPrvacyPage = document.querySelector(".column-view") && document.querySelector(".column-view");

    useEffect(() => {
      const buttonPdf = document.querySelector(".print-btn");
      console.log(buttonPdf);
      buttonPdf?.addEventListener("click", (event) => {
        const target = event.currentTarget;
        console.log(target);
        window && window.print();
      })
    }, []);
  }

  return (
    <>
      {props?.fields && (
        <div className="privacy-pdf-btn text-module--center">
          {model?.downloadLink?.value?.href ?
            <Link field={model?.downloadLink} download target="_blank">
              <div className="print-btn-link">
                <Image className="pdf-icon" field={model?.icon as any} />
                {model?.label?.value}
              </div>
            </Link>
            :
            <div className="print-btn">
              <Image className="pdf-icon" field={model?.icon as any} />
              {model?.label?.value}
            </div>
          }
        </div>
      )}
    </>

  );
};

export default withSitecoreContext()(IconButton);
